import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const SearchEyeIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
    {/* Search */}
    <path
      d="M18.5 18.5L15.1945 15.1944M17.5556 9.52778C17.5556 13.9614 13.9614 17.5556 9.52778 17.5556C5.09416 17.5556 1.5 13.9614 1.5 9.52778C1.5 5.09416 5.09416 1.5 9.52778 1.5C13.9614 1.5 17.5556 5.09416 17.5556 9.52778Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />

    {/* Eye */}
    <path
      d="M5.11983 9.94432C5.05798 9.84104 5.02706 9.78939 5.00975 9.70974C4.99675 9.64991 4.99675 9.55556 5.00975 9.49573C5.02706 9.41607 5.05798 9.36443 5.11983 9.26115C5.63088 8.40765 7.15209 6.25 9.47031 6.25C11.7885 6.25 13.3097 8.40765 13.8208 9.26115C13.8826 9.36443 13.9136 9.41607 13.9309 9.49573C13.9439 9.55556 13.9439 9.64991 13.9309 9.70974C13.9136 9.78939 13.8826 9.84104 13.8208 9.94432C13.3097 10.7978 11.7885 12.9555 9.47031 12.9555C7.15209 12.9555 5.63088 10.7978 5.11983 9.94432Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />

    {/* Pupil */}
    <circle cx="9.47012" cy="9.60195" r="1.11758" fill="currentColor" />
  </SvgIcon>
);
